import React, { memo, useState, useCallback } from 'react'

import { SectionContainer } from './common-styles'
import {
    Section,
    ContentContainer,
    TitleContainer,
    DescriptionContainer,
    LogoContainer,
    ExtraContentContainer,
    ExtraContentDescription,
    ExtraContentTitle,
    DownArrow,
    UpArrow,
    InnerContainer,
} from './money-back-guarantee-section-styles'
import { MoneyBackGuaranteeSectionTransport } from '@common/transports/deprecated-home-page-transport'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'
import { homePageEventLabels } from '@src/services/analytics-service/labels'

interface Props {
    moneyBackGuaranteeSection: MoneyBackGuaranteeSectionTransport
}

const MoneyBackGuaranteeSection: React.FC<Props> = ({
    moneyBackGuaranteeSection: { id, title, description, image, showMoreText, additionalText },
}) => {
    const [isExtraContentVisible, setExtraContentVisible] = useState(false)

    const toggleExtraContent = useCallback(() => {
        if (!isExtraContentVisible) {
            AnalyticsService.trackClickEvent(
                homePageEventCategories.MONEY_BACK_GUARANTEE_SECTION,
                homePageEventLabels.moneyBackGuaranteeSection.SHOW_MORE,
            )
        }
        setExtraContentVisible(!isExtraContentVisible)
    }, [setExtraContentVisible, isExtraContentVisible])

    return (
        <SectionContainer id={id}>
            <Section>
                <InnerContainer>
                    <LogoContainer src={image.url} alt={image.alt} />
                    <ContentContainer>
                        <TitleContainer>{title}</TitleContainer>
                        <DescriptionContainer>{description}</DescriptionContainer>
                        <ExtraContentContainer>
                            <ExtraContentTitle onClick={toggleExtraContent}>
                                {showMoreText}&nbsp;
                                {isExtraContentVisible ? <UpArrow alt="Up Arrow" /> : <DownArrow alt="Down Arrow" />}
                            </ExtraContentTitle>
                            <ExtraContentDescription
                                inputText={additionalText}
                                escapeHtml
                                isVisible={isExtraContentVisible}
                            />
                        </ExtraContentContainer>
                    </ContentContainer>
                </InnerContainer>
            </Section>
        </SectionContainer>
    )
}

export default memo(MoneyBackGuaranteeSection)
